import React, {Fragment} from 'react'


function LoginLanding() {

    return (
        <Fragment>
        <div className="form-label">Please check your email</div>
        <p>Your will need to click on the link in the email we sent you to login</p>
        </Fragment>
    )
}

export default LoginLanding
